import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export interface IScene {
  // # AI智能接待
  REFUND: string;
  SENT_MISTAKE: string;
  PROBLEM_OF_PRODUCT: string;
  RE_REMARK_SKU_REQ: string;
  MODIFY_TRADE_REQ: string;
  BARGAIN_MSG: string;
  CANCEL_ORDER_REQ: string;
  ITEM_CHANGE_REQ: string;
  // # 用户标签
  VALUABLE_BUYER: string;
  // # 退货退款挽回
  RETURN_REFUND_RETRIEVE: string;
  // ## 退货退款挽回的子选项
  RETURN_REFUND_ITEM_MISSING: string;
  RETURN_REFUND_WRONG_ITEM: string;
  RETURN_REFUND_PHYSICAL_DMG: string;
  RETURN_REFUND_FUNCTIONAL_DMG: string;
  RETURN_REFUND_NOT_RECEIPT: string;
  // # 仅退款挽回
  REFUND_RETRIEVE: string;
  // ## 仅退款挽回的子选项
  ONLY_REFUND_ITEM_MISSING: string;
  ONLY_REFUND_WRONG_ITEM: string;
  ONLY_REFUND_PHYSICAL_DMG: string;
  ONLY_REFUND_FUNCTIONAL_DMG: string;
  ONLY_REFUND_NOT_RECEIPT: string;
  // # 取消订单挽回
  CANCEL_ORDER_RETRIEVE: string;
  // ## 取消订单挽回的子选项
  CANCELLED_TRADE_CHANGE_VOUCHER: string;
  CANCELLED_TRADE_MODIFY_ORDER: string;
  CANCELLED_TRADE_CHANGE_MIND: string;
  CANCELLED_TRADE_FOUND_CHEAPER: string;
  CANCELLED_TRADE_TOO_TROUBLESOME: string;
  CANCELLED_TRADE_OTHERS: string;
  CANCELLING_TRADE_CHANGE_ADDRESS: string;
  CANCELLING_TRADE_MODIFY_ORDER: string;
  CANCELLING_TRADE_OTHERS: string;
  CANCELLING_TRADE_IRRESPONDING: string;
  // # 中差评挽回
  NEGATIVE_RATE_RETRIEVE: string;
}

const useI18nScene = (): IScene => {
  const { t } = useTranslate();

  return useMemo(() => {
    return {
      REFUND: t('newScene.REFUND'),
      SENT_MISTAKE: t('newScene.SENT_MISTAKE'),
      PROBLEM_OF_PRODUCT: t('newScene.PROBLEM_OF_PRODUCT'),
      RE_REMARK_SKU_REQ: t('newScene.RE_REMARK_SKU_REQ'),
      MODIFY_TRADE_REQ: t('newScene.MODIFY_TRADE_REQ'),
      BARGAIN_MSG: t('newScene.BARGAIN_MSG'),
      CANCEL_ORDER_REQ: t('newScene.CANCEL_ORDER_REQ'),
      ITEM_CHANGE_REQ: t('newScene.ITEM_CHANGE_REQ'),
      VALUABLE_BUYER: t('newScene.VALUABLE_BUYER'),
      RETURN_REFUND_RETRIEVE: t('newScene.RETURN_REFUND_RETRIEVE'),
      REFUND_RETRIEVE: t('newScene.REFUND_RETRIEVE'),
      CANCELLED_TRADE_TOO_TROUBLESOME: t('newScene.CANCELLED_TRADE_TOO_TROUBLESOME'),
      RETURN_REFUND_ITEM_MISSING: t('aide.收到货物少件'),
      RETURN_REFUND_WRONG_ITEM: t('aide.收到货物错误'),
      RETURN_REFUND_PHYSICAL_DMG: t('aide.收到货物破损'),
      RETURN_REFUND_FUNCTIONAL_DMG: t('aide.收到货物无法使用'),
      RETURN_REFUND_NOT_RECEIPT: t('aide.未收到货物'),
      ONLY_REFUND_ITEM_MISSING: t('aide.收到货物少件'),
      ONLY_REFUND_WRONG_ITEM: t('aide.收到货物错误'),
      ONLY_REFUND_PHYSICAL_DMG: t('aide.收到货物破损'),
      ONLY_REFUND_FUNCTIONAL_DMG: t('aide.收到货物无法使用'),
      ONLY_REFUND_NOT_RECEIPT: t('aide.未收到货物'),
      CANCEL_ORDER_RETRIEVE: t('aide.取消订单挽回'),
      CANCELLED_TRADE_CHANGE_VOUCHER: t('refundSetting.修改优惠券'),
      CANCELLED_TRADE_MODIFY_ORDER: t('aide.修改订单'),
      CANCELLED_TRADE_CHANGE_MIND: t('aide.不想买了'),
      CANCELLED_TRADE_FOUND_CHEAPER: t('aide.在别处找到更便宜的'),
      CANCELLED_TRADE_OTHERS: t('aide.其他'),
      CANCELLING_TRADE_CHANGE_ADDRESS: t('refundSetting.修改收货地址'),
      CANCELLING_TRADE_MODIFY_ORDER: t('aide.修改已有订单'),
      CANCELLING_TRADE_OTHERS: t('aide.其他改变主意'),
      CANCELLING_TRADE_IRRESPONDING: t('aide.卖家不响应咨询'),
      NEGATIVE_RATE_RETRIEVE: t('aide.中差评挽回'),
      TAX_REMIND: t('aide.等待缴税'),
      NEGATIVE_RATE_PRONE_BUYER: t('chat_side_negative_buyer_tag'),
      RETURN_TRADE_ITEM_MISSING: t('aide.收到货物少件'),
      RETURN_TRADE_WRONG_ITEM: t('aide.收到货物错误'),
      RETURN_TRADE_PHYSICAL_DMG: t('aide.收到货物破损'),
      RETURN_TRADE_FUNCTIONAL_DMG: t('aide.收到货物无法使用'),
      RETURN_TRADE_NOT_RECEIPT: t('aide.未收到货物'),
    };
  }, [t]);
};

export default useI18nScene;
